import React, {useState} from "react";
import {Button, Form, Input, message, Modal, Spin} from "antd";
import styles from "../index.module.scss";
import {verifyMobile} from "../../../../api/credentialsRequests";
import {CAMPAIGN_NAME} from "../../../../environment";

const formFieldBadCodeMessage = "Il codice deve essere lungo esattamente 6 caratter";
const formFieldMissingMessage = "Il campo è obbligatorio";

const VerifyMobileForm =
({
  isModalOpen,
  toggleModal,
  loading,
  setLoading,
  mobile,
  translateErrors,
  setMobileVerified,
}) => {
  const [verifyMobileFormErrors, setVerifyMobileFormErrors] = useState("");

  // Form reference
  const [verifyMobileForm] = Form.useForm();

// invoked by the mobile verify form if there are no completion errors
  const onMobileOk = async (values) => {
    setLoading(true);

    try {
      await verifyMobile({
        ...values,
        mobile: mobile,
        campaign_name: CAMPAIGN_NAME,
      })
      message.success("Registrazione avvenuta con successo!");
      setMobileVerified(true);
      toggleModal();
      verifyMobileForm.resetFields();
    } catch(err) {
      try {
        const {
          data = {},
        } = err.response || {};
        const {
          message: errorMessage = null,
        } = data || {};

        switch (true) {
          case typeof errorMessage === 'string' || errorMessage instanceof String:
            message.error(translateErrors(errorMessage));
            break;
          case Object.keys(errorMessage).length > 0:
            setVerifyMobileFormErrors(errorMessage);
            break;
          default:
            message.error('Si è verififcato un errore, ti preghiamo di riprovare');
        }
      } catch (e) {
        console.error(e);
        message.error('Si è verififcato un errore, ti preghiamo di riprovare');
      }
    }

    setLoading(false);
  };

// invoked by the mobile verify form if there are completion errors
  const onMobileFailed = () => {
    message.error("Si è verificato un errore, ti preghiamo di riprovare");
  };

  const validateVerifyMobileProps = key => {
    const {
      [key]: fieldErrors = [],
    } = verifyMobileFormErrors || {};

    if (fieldErrors.length > 0) {
      return {
        validateStatus: 'error',
        help: fieldErrors.map(translateErrors).join("\n")
      }
    }

    return {};
  }

  return (
    <Modal
      style={{textAlign: "center"}}
      open={isModalOpen}
      cancelText="Annulla"
      onCancel={toggleModal}
      title="Inserisci il codice che ti abbiamo inviato tramite SMS"
      footer={[
        <Button
          key="back"
          onClick={toggleModal}
        >
          Annulla
        </Button>
      ]}
    >
      <p>Il codice scade tra 5 minuti</p>
      <Form
        form={verifyMobileForm}
        onFinish={onMobileOk}
        onFinishFailed={onMobileFailed}
        scrollToFirstError
      >
        <Form.Item
          key="token"
          name="token"
          rules={[
            {required: true, message: formFieldMissingMessage},
            {min: 6, message: formFieldBadCodeMessage},
            {max: 6, message: formFieldBadCodeMessage},
          ]}
          {...validateVerifyMobileProps("token")}

        >
          <Input
            autoFocus
            style={{width: "100%"}}
          />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className={styles.formSubmitBtn}
            disabled={loading}
          >
            {
              loading ?
                <Spin /> :
                "Conferma"
            }
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default VerifyMobileForm;